export * as Debug from './adsDebugging.js';
export var Device;
(function (Device) {
    Device["DESKTOP"] = "desktop";
    Device["MOBILE"] = "mobile";
    Device["ALL"] = "all";
})(Device || (Device = {}));
export var RefreshReason;
(function (RefreshReason) {
    RefreshReason[RefreshReason["BREAKPOINT_CHANGE"] = 0] = "BREAKPOINT_CHANGE";
    RefreshReason[RefreshReason["USER_INTERACTION"] = 1] = "USER_INTERACTION";
})(RefreshReason || (RefreshReason = {}));
//# sourceMappingURL=ads.js.map